var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.431,
    x2: 295.145,
    xlinkHref: "#lg1",
    y1: 217.569,
    y2: 336.283
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 242,
    y2: 197.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.078,
    x2: 371.472,
    y1: 321.503,
    y2: 520.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe860a"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.954,
    x2: 105.861,
    xlinkHref: "#lg2",
    y1: 408.902,
    y2: 226.243
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.175,
    x2: 230.868,
    xlinkHref: "#lg2",
    y1: 353.289,
    y2: 519.191
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 474.742,
    y2: 519.89
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#dce8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7423,
    stopColor: "#b8c4ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2aee6"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.15,
    x2: 266.184,
    xlinkHref: "#lg3",
    y1: 304.424,
    y2: 375.458
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192a7d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -173.822 740.011)",
    gradientUnits: "userSpaceOnUse",
    x1: -358.46,
    x2: -335.074,
    xlinkHref: "#lg4",
    y1: -663.843,
    y2: -640.457
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1843.382 740.011)",
    gradientUnits: "userSpaceOnUse",
    x1: -1901.683,
    x2: -1878.297,
    xlinkHref: "#lg4",
    y1: 879.38,
    y2: 902.765
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.563,
    x2: 106.739,
    xlinkHref: "#lg1",
    y1: 91.095,
    y2: 91.095
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.442,
    x2: 119.746,
    xlinkHref: "#lg3",
    y1: 29.813,
    y2: 29.813
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -173.822 740.011)",
    gradientUnits: "userSpaceOnUse",
    x1: -114.679,
    x2: -91.294,
    xlinkHref: "#lg4",
    y1: -907.623,
    y2: -884.238
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1843.382 740.011)",
    gradientUnits: "userSpaceOnUse",
    x1: -2145.463,
    x2: -2122.078,
    xlinkHref: "#lg4",
    y1: 1123.161,
    y2: 1146.546
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.321,
    x2: 451.497,
    xlinkHref: "#lg1",
    y1: 91.095,
    y2: 91.095
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.2,
    x2: 464.504,
    xlinkHref: "#lg3",
    y1: 29.813,
    y2: 29.813
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 124.977,
    y2: 200.108
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795de",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#7d8ddc",
    stopOpacity: 0.468
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c7fd8"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.237,
    x2: 183.237,
    xlinkHref: "#lg5",
    y1: 181.808,
    y2: 111.808
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.234,
    x2: 334.428,
    xlinkHref: "#lg5",
    y1: 250.794,
    y2: 142.988
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 164,
    y2: 196.14
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.144,
    x2: 326.156,
    xlinkHref: "#lg3",
    y1: 60.93,
    y2: 186.941
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.429,
    x2: 105.429,
    xlinkHref: "#lg5",
    y1: 158.269,
    y2: 4.269
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 185,
    y2: 229
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.599,
    x2: 255.51,
    xlinkHref: "#lg5",
    y1: 211.401,
    y2: 122.312
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.906,
    x2: 282.52,
    xlinkHref: "#lg1",
    y1: 95.71,
    y2: 149.324
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.83,
    x2: 230.073,
    xlinkHref: "#lg1",
    y1: 135.634,
    y2: 96.878
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.815,
    x2: 269.401,
    xlinkHref: "#lg4",
    y1: 109.619,
    y2: 136.205
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.785 391.692-15.57-19.559 70.156-55.851c6.172-4.914 9.712-12.257 9.712-20.146s-3.54-15.231-9.712-20.146l-156.371-124.483-156.371 124.485c-6.172 4.914-9.712 12.257-9.712 20.146s3.54 15.231 9.712 20.146l70.156 55.851-15.57 19.559-70.156-55.851c-12.165-9.685-19.142-24.155-19.142-39.704s6.977-30.02 19.141-39.704l171.942-136.883 171.941 136.882c12.165 9.685 19.142 24.155 19.142 39.704s-6.977 30.02-19.142 39.704z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.941 256.434-171.941-136.882-171.942 136.882c-1.412 1.124-2.746 2.319-4.016 3.566h39.675l136.283-108.493 136.283 108.493h39.675c-1.27-1.247-2.604-2.442-4.017-3.566z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m370.48 510h-230.96c-5.188 0-9.394-4.206-9.394-9.394v-192.363c0-5.188 4.206-9.394 9.394-9.394h230.96c5.188 0 9.394 4.206 9.394 9.394v192.363c0 5.188-4.206 9.394-9.394 9.394z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.874 308.242v192.365c0 5.186-4.207 9.393-9.392 9.393h-30.655l-151.304-151.304v-59.847h181.959c5.186 0 9.392 4.207 9.392 9.393z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.48 298.848h-65.62c5.188 0 9.394 4.206 9.394 9.394v192.363c0 5.188-4.206 9.394-9.394 9.394h65.62c5.188 0 9.394-4.206 9.394-9.394v-192.362c0-5.189-4.206-9.395-9.394-9.395z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.126 459.071v41.535c0 5.188 4.206 9.394 9.394 9.394h230.96c5.188 0 9.394-4.206 9.394-9.394v-41.535z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198.165 360.305.184.112c4.223 2.564 9.532 2.521 13.712-.112 4.272-2.58 9.622-2.58 13.895 0 4.272 2.58 9.622 2.58 13.895 0h.001c1.98-1.146 4.171-1.171 6.377-.757 2.517.472 4.854-1.415 4.854-3.975v-54.814c0-1.825-1.48-3.305-3.305-3.305h-57.541c-1.825 0-3.305 1.48-3.305 3.305v54.736c0 2.545 2.315 4.451 4.816 3.982 2.228-.418 4.439-.373 6.417.828z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.004 25.412-42.748-13.101c-25.556-7.832-38.626.39-39.247 14.605-.006.139-.009.279-.009.418 0 .14.003.279.009.418.621 14.216 13.691 22.438 39.247 14.606l42.749-13.101c2.97-.91 2.97-2.935-.001-3.845z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.238 25.412 42.749-13.101c25.556-7.832 38.626.39 39.247 14.605.006.139.009.279.009.418 0 .14-.003.279-.009.418-.62 14.215-13.691 22.437-39.247 14.605l-42.749-13.1c-2.971-.91-2.971-2.935 0-3.845z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.621 29.813c-8.295 0-15.02 21.277-15.02 47.524v45.774c0 16.162 5.468 29.264 12.214 29.264h5.613c6.745 0 12.214-13.102 12.214-29.264v-45.773c-.001-26.247-6.726-47.525-15.021-47.525z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.621 0c-12.769 0-23.121 10.351-23.121 23.121v22.269c0 7.863 8.417 14.237 18.801 14.237h8.64c10.383 0 18.801-6.374 18.801-14.237v-22.269c0-12.77-10.352-23.121-23.121-23.121z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.762 25.412-42.749-13.101c-25.556-7.832-38.626.39-39.247 14.605-.006.139-.009.279-.009.418 0 .14.003.279.009.418.62 14.215 13.691 22.437 39.247 14.605l42.749-13.101c2.971-.909 2.971-2.934 0-3.844z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.996 25.412 42.749-13.101c25.556-7.832 38.626.39 39.247 14.605.006.139.009.279.009.418 0 .14-.003.279-.009.418-.62 14.215-13.691 22.437-39.247 14.605l-42.749-13.101c-2.971-.909-2.971-2.934 0-3.844z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m427.379 29.813c-8.295 0-15.02 21.277-15.02 47.524v45.774c0 16.162 5.468 29.264 12.214 29.264h5.613c6.745 0 12.214-13.102 12.214-29.264v-45.773c-.001-26.247-6.726-47.525-15.021-47.525z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.379 0c-12.769 0-23.121 10.351-23.121 23.121v22.269c0 7.863 8.417 14.237 18.801 14.237h8.64c10.383 0 18.801-6.374 18.801-14.237v-22.269c0-12.77-10.352-23.121-23.121-23.121z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.625 195.473h-375.25c-22.781 0-41.248-18.467-41.248-41.248 0-22.781 18.467-41.248 41.248-41.248h375.25c22.781 0 41.248 18.467 41.248 41.248 0 22.781-18.467 41.248-41.248 41.248z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.845 112.977h-135.47c-22.781 0-41.248 18.468-41.248 41.248 0 22.781 18.467 41.248 41.248 41.248h135.47z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.802 195.473h146.823c9.901 0 18.984-3.491 26.093-9.306l-73.19-73.19h-99.726z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.127 154.225c0 22.781 18.467 41.248 41.248 41.248h375.25c22.781 0 41.248-18.467 41.248-41.248 0-2.466-.229-4.878-.644-7.225h-456.458c-.415 2.347-.644 4.759-.644 7.225z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m396.852 123.831c0-43.765-63.509-79.244-141.852-79.244s-141.852 35.479-141.852 79.244c0 10.929 17.695 19.128 44.245 24.598 18.33 3.776 31.495 19.902 31.495 38.616 0 21.774 17.652 39.426 39.426 39.426h53.371c21.775 0 39.426-17.652 39.426-39.426 0-18.715 13.166-34.84 31.495-38.616 26.551-5.47 44.246-13.668 44.246-24.598z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.685 226.472c21.774 0 39.426-17.652 39.426-39.426 0-18.715 13.166-34.84 31.495-38.616 26.55-5.47 44.245-13.669 44.245-24.598 0-43.765-63.509-79.244-141.852-79.244v181.885h26.686z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.1 158c7.923 7.27 12.788 17.677 12.788 29.046 0 21.774 17.652 39.426 39.426 39.426h53.371c21.774 0 39.426-17.652 39.426-39.426 0-11.369 4.865-21.776 12.788-29.046z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m342.654 151.918-55.785-55.785c-7.48-8.65-18.53-14.13-30.87-14.13-22.53 0-40.8 18.26-40.8 40.8 0 1.76.11 3.49.33 5.19 1.3 10.23 6.38 19.27 13.81 25.68l69.076 69.076c13.409-6.294 22.697-19.911 22.697-35.703 0-15.112 8.587-28.531 21.542-35.128z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 121.804,
    fill: "url(#SVGID_24_)",
    r: 40.802
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 121.804,
    fill: "url(#SVGID_25_)",
    r: 29.898
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 121.804,
    fill: "url(#SVGID_26_)",
    r: 18.606
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrone);
export default __webpack_public_path__ + "static/media/icon-drone.300977a5d79b75bb69f2e43f8334e23f.svg";
export { ForwardRef as ReactComponent };